var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "DialogBase",
        {
          attrs: {
            title: "Thêm tài khoản ngân hàng",
            visible: _vm.isOpenAddAccountBankToBrandDialog,
            width: "550px",
            "panel-icon": "el-icon-bank",
            "panel-title": "LIÊN KẾT TÀI KHOẢN NGÂN HÀNG CÓ SẴN",
            "panel-subtitle":
              "Chọn đại lý quản lý và tài khoản ngân hàng API có sẵn để thực hiện liên kết.",
            "confirm-loading": _vm.loading.submit,
            "confirm-text": "Xác nhận thêm",
            "cancel-text": "Hủy bỏ",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isOpenAddAccountBankToBrandDialog = $event
            },
            "before-close": _vm.handleClose,
            cancel: _vm.handleClose,
            confirm: _vm.submitForm,
            open: _vm.handleOpen,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "formData",
              staticClass: "modern-form",
              attrs: {
                model: _vm.formData,
                rules: _vm.rules,
                "label-position": "top",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "Chọn Đại lý quản lý", prop: "idxCompany" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "full-width",
                      attrs: {
                        filterable: "",
                        clearable: "",
                        placeholder: "Chọn đại lý...",
                      },
                      model: {
                        value: _vm.formData.idxCompany,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "idxCompany", $$v)
                        },
                        expression: "formData.idxCompany",
                      },
                    },
                    _vm._l(_vm.companies, function (item) {
                      return _c("el-option", {
                        key: item.idxCompany,
                        attrs: {
                          value: item.idxCompany,
                          label: item.companyName,
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "Chọn Tài khoản ngân hàng API",
                    prop: "idBank",
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "full-width",
                      attrs: {
                        filterable: "",
                        clearable: "",
                        placeholder: "Chọn tài khoản...",
                      },
                      model: {
                        value: _vm.formData.idBank,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "idBank", $$v)
                        },
                        expression: "formData.idBank",
                      },
                    },
                    _vm._l(_vm.banks, function (item) {
                      return _c("el-option", {
                        key: item.idBank,
                        attrs: { value: item.idBank, label: item.bankName },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }